import OButton from 'components/reusable/OButton'
import useToastContext from 'hooks/useToastContext'
import React, { useContext, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Permission from './Permission'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import formValidation from 'utils/formValidation'
import OTextArea from 'components/reusable/OTextArea'
import PhoneInput from 'react-phone-input-2'
import ErrorMessage from 'components/ErrorMessage'
import AuthContext from 'context/AuthContext'
import OMultiSelect from 'components/reusable/OMultiSelect'
import {
  DEFAULT_ALLOWED_UNIT_STATUSES,
  multiValueToStatuses,
  statusesToMultiValue,
  UNIT_PROPOSAL_STATUS_OPTIONS,
} from './unitProposalStatuses'
const { startCase, capitalize } = require('lodash')

const SubAdd = ({ setShowModal, allSubAdmin }) => {
  const { t } = useTranslation()
  const inputRef = useRef(null)
  const { defaultCountry } = useContext(AuthContext)
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    clearErrors,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      canCreateUnitProposal: true,
      allowedUnitProposalStatuses: statusesToMultiValue(
        DEFAULT_ALLOWED_UNIT_STATUSES
      )
    }
  })
  const canCreateProposal = watch('canCreateUnitProposal')
  const canCreateReg = register('canCreateUnitProposal')
  const notification = useToastContext()
  const [permissionJons, setPermission] = useState(Permission)
  const [loading, setLoading] = useState(false)

  const onChange = event => {
    setPermission(current =>
      current.map(obj => {
        if (obj.manager === event.target.name) {
          if (event.target.id === 'add') {
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              view: event.target.checked
            }
          }
          if (event.target.id === 'import') {
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              import: event.target.checked
            }
          }
          if (event.target.id === 'delete' && event.target.checked) {
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              view: event.target.checked
            }
          } else if (event.target.id === 'view' && !event.target.checked) {
            return {
              ...obj,
              add: false,
              view: false,
              delete: false,
              import: false,
              all: false
            }
          }
          return { ...obj, [event.target.id]: event.target.checked }
        }
        return obj
      })
    )
  }
  const checkAll = event => {
    setPermission(current =>
      current.map(obj => {
        if (obj.manager === event.target.name) {
          return {
            ...obj,
            add: event.target.checked,
            import: event.target.checked,
            view: event.target.checked,
            delete: event.target.checked
          }
        }
        return obj
      })
    )
  }

  const onSubmit = async data => {
    setLoading(true)

    data.countryCode = inputRef?.current?.state.selectedCountry?.countryCode
    data.mobile = data?.mobile?.substring(
      inputRef?.current?.state.selectedCountry?.countryCode?.length,
      data?.mobile?.toString()?.length
    )
    const {
      allowedUnitProposalStatuses,
      ...myData
    } = data
    try {
      const path = apiPath.addSubAdmin
      const myObj = {
        manager: 'dashboard',
        add: true,
        view: true,
        delete: true
      }
      const permission = JSON.stringify([myObj, ...permissionJons])
      const sendData = {
        ...myData,
        permission,
        allowedUnitProposalStatus: myData.canCreateUnitProposal
          ? multiValueToStatuses(allowedUnitProposalStatuses ?? [])
          : []
      }
      const result = await apiPost(path, sendData)
      if (result?.data?.success) {
        allSubAdmin()
        setShowModal(false)
        notification.success(result.data.message)
      } else {
        notification.error(result.data.message)
        // setShowModal(false)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
    setLoading(false)
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative my-6  w-full max-w-[1150px] mx-auto'>
          <div className='sm:py-4 sm:px-2 py-8 px-7 '>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {t('SUB_ADMIN_ADD_SUB_ADMIN')}
                </h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
                  <div className='px-2'>
                    {/* <div className='relative z-0 mb-6 w-full group'>
                      <input
                        type='text'
                        id='firstName'
                        maxLength={15}
                        autocomplete="off"
                        autoFocus={true}
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                        placeholder=' '
                        {...register('firstName', {
                          required: 'First name is required.',
                          minLength: {
                            value: 2,
                            message: 'Minimum length must be 2.'
                          },
                          validate: (value) => {
                            return value.trim()
                              ? true
                              : 'White spaces not allowed.'
                          }
                        })}
                      />
                      <label
                        htmlFor='firstName'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_FIRST_NAME')}<span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.firstName?.message} />
                    </div> */}
                    <OInputField
                      wrapperClassName='relative z-0 w-full group'
                      name='firstName'
                      inputLabel={
                        <>
                          {t('O_FIRST_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      autoFocus
                      register={register(
                        'firstName',
                        formValidation.subFirstName
                      )}
                      errors={errors}
                    />
                  </div>

                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='lastName'
                      inputLabel={
                        <>
                          {t('O_LAST_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      register={register(
                        'lastName',
                        formValidation.subLastName
                      )}
                      errors={errors}
                    />
                  </div>

                  {/* <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='mobile'
                      onInput={e => preventMax(e)}
                      inputLabel={
                        <>
                          {t('O_MOBILE_NUMBER')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='number'
                      register={register('mobile', formValidation.mobile)}
                      errors={errors}
                    />
                  </div> */}

                  <div className='px-2'>
                    <label
                      htmlFor={'mobile'}
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Mobile
                    </label>
                    <Controller
                      control={control}
                      name='mobile'
                      rules={{
                        required: t('PLEASE_ENTER_MOBILE_NUMBER'),
                        validate: value => {
                          const inputValue = value
                            ?.toString()
                            ?.slice(
                              inputRef?.current?.state?.selectedCountry
                                ?.countryCode?.length,
                              value?.length
                            )
                          if (inputValue?.length < 8) {
                            return t(
                              'MOBILE_NUMBER_MUST_CONTAIN_AT_LEAST_8_DIGITS'
                            )
                          } else if (inputValue?.length > 12) {
                            return t(
                              'MOBILE_NUMBER_SHOULD_NOT_EXCEED_12_DIGITS'
                            )
                          } else {
                            return true
                          }
                        }
                      }}
                      render={({ field: { ref, ...field } }) => (
                        <PhoneInput
                          {...field}
                          inputExtraProps={{
                            ref,
                            required: true,
                            autoFocus: true
                          }}
                          ref={inputRef}
                          inputStyle={{
                            width: '100%',
                            height: '42px'
                          }}
                          style={{ borderRadius: '20px' }}
                          country={defaultCountry}
                          enableSearch
                          countryCodeEditable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.mobile?.message} />
                  </div>
                  {/* <div className='px-2'>
                    <div className='relative z-0 mb-6 w-full group'>
                      <input
                        type={icon ? 'password' : 'text'}
                        id='password'
                        placeholder=' '
                        autocomplete="off"
                        maxLength={15}
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                        autoComplete='new-password'
                        {...register('password', {
                          required: 'Password is required.',
                          pattern: {
                            value: validationRules.password,
                            message:
                              'Password must contain lowercase,uppercase characters, numbers, special character and at least 8 character long.'
                          },
                          validate: (value) => {
                            return value.trim()
                              ? true
                              : 'White spaces not allowed.'
                          }
                        })}
                      />
                      <label
                        htmlFor='password'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_PASSWORD')}<span className='text-red-500'>*</span>
                      </label>
                      {
                        icon ? <span className='password_view absolute top-[18px] right-[20px]' onClick={() => changeIcon()}><AiFillEyeInvisible /></span> : <span className='password_view absolute top-[18px] right-[20px]' onClick={() => changeIcon()}><AiFillEye /></span>
                      }
                      <ErrorMessage message={errors?.password?.message} />
                    </div>
                  </div>
                  <div className='px-2'>
                    <div className='relative z-0 mb-6 w-full group'>
                      <input
                        type={passwordIcon ? 'password' : 'text'}
                        id='confirm_password'
                        placeholder=' '
                        autocomplete="off"
                        maxLength={15}
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                        autoComplete='new-password'
                        {...register('confirm_password', {
                          required: 'Confirm password is required.',
                          validate: (val) => {
                            if (watch('password') !== val) {
                              return 'Your password and confirm password do not match.'
                            }
                          }
                        })}
                      />
                      <label
                        htmlFor='confirm_password'
                        className='peer-focus:font-normal  absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_CONFIRM_PASSWORD')}<span className='text-red-500'>*</span>
                      </label>
                      {
                        passwordIcon ? <span className='password_view absolute top-[18px] right-[20px]' onClick={() => changePasswordIcon()}><AiFillEyeInvisible /></span> : <span className='password_view absolute top-[18px] right-[20px]' onClick={() => changePasswordIcon()}><AiFillEye /></span>
                      }
                      <ErrorMessage
                        message={errors?.confirm_password?.message}
                      />
                    </div>
                  </div> */}
                  <div className='px-2'>
                    {/* <div className='relative z-0 mb-6 w-full group'>
                      <input
                        type='text'
                        name='email'
                        maxLength={50}
                        autocomplete='off'
                        placeholder=' '
                        id='email'
                        autoComplete='off'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                        {...register('email', {
                          required: 'Email is required.',
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message:
                              'Invalid email address (Ex: example@domain.com).'
                          },
                          validate: value => {
                            return value.trim()
                              ? true
                              : 'White spaces not allowed.'
                          }
                        })}
                      />
                      <label
                        htmlFor='email'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_EMAIL_ID')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.email?.message} />
                    </div> */}
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='email'
                      inputLabel={
                        <>
                          {t('O_EMAIL_ID')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='email'
                      register={register('email', formValidation.email)}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2'>
                    <OTextArea
                      wrapperClassName='relative z-0 my-6 w-full group'
                      name='address'
                      inputLabel={
                        <>
                          {t('SUB_ADMIN_ADDRESS')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='textarea'
                      register={register('address', formValidation.address)}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2 w-full col-span-full md:col-span-2 lg:col-span-4'>
                    <label className='flex items-center gap-2 text-sm text-gray-900 cursor-pointer'>
                      <input
                        type='checkbox'
                        className='rounded border-gray-300'
                        {...canCreateReg}
                        onChange={(e) => {
                          canCreateReg.onChange(e)
                          if (!e.target.checked) {
                            setValue('allowedUnitProposalStatuses', [], {
                              shouldDirty: true,
                            })
                            clearErrors('allowedUnitProposalStatuses')
                          }
                        }}
                      />
                      <span>
                        {t('CAN_CREATE_UNIT_PROPOSAL', 'Can create unit proposals')}
                      </span>
                    </label>
                  </div>
                </div>
                {canCreateProposal ? (
                  <div className='px-6 pb-4 relative z-[60] isolate'>
                    <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                      {t(
                        'ALLOWED_UNIT_PROPOSAL_STATUSES',
                        'Allowed unit proposal statuses'
                      )}
                    </label>
                    <Controller
                      control={control}
                      name='allowedUnitProposalStatuses'
                      rules={{
                        validate: (v, formValues) => {
                          if (!formValues.canCreateUnitProposal) return true
                          if (Array.isArray(v) && v.length > 0) return true
                          return t(
                            'SELECT_AT_LEAST_ONE_STATUS',
                            'Select at least one status when creation is enabled.'
                          )
                        },
                      }}
                      render={({ field }) => (
                        <OMultiSelect
                          placeholder={t(
                            'SELECT_UNIT_STATUSES',
                            'Select statuses…'
                          )}
                          options={UNIT_PROPOSAL_STATUS_OPTIONS}
                          value={field.value ?? []}
                          onChange={(v) => field.onChange(v ?? [])}
                          wrapperClassName='relative z-[60] mb-2 w-full max-w-2xl group'
                        />
                      )}
                    />
                    <ErrorMessage
                      message={errors?.allowedUnitProposalStatuses?.message}
                    />
                  </div>
                ) : null}
                <div className='pl-3 pr-3 h-56 overflow-y-scroll'>
                  <div className='overflow-x-auto  overflow-y-auto relative rounded-lg border'>
                    <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
                      <thead className='text-xs text-gray-900 border  border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                        <tr>
                          <th scope='col' className='py-3 px-6 '>
                            {t('SUB_ADMIN_MANAGER')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_VIEW')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('SUB_ADMIN_ADD_EDIT')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_DELETE')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('IMPORT')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_ALL')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {permissionJons?.map((item, i) => (
                          <tr
                            key={i}
                            className='bg-white border-b  dark:bg-gray-800 dark:border-gray-700'
                          >
                            <td className='py-2 px-2 border-r '>
                              {capitalize(startCase(item.manager))}
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {item?.shownView && (
                                <input
                                  type='checkbox'
                                  name={item?.manager}
                                  id='view'
                                  checked={item.view}
                                  onChange={onChange}
                                  title={t('O_VIEW')}
                                />
                              )}
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {item?.shownEdit && (
                                <input
                                  type='checkbox'
                                  id='add'
                                  name={item?.manager}
                                  checked={item.add}
                                  onChange={onChange}
                                  title={t('SUB_ADMIN_ADD_EDIT')}
                                />
                              )}
                            </td>

                            <td className='py-2 px-2 border-r '>
                              {item?.shownDelete && (
                                <input
                                  type='checkbox'
                                  name={item?.manager}
                                  id='delete'
                                  checked={item.delete}
                                  onChange={onChange}
                                  title={t('O_DELETE')}
                                />
                              )}
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {item?.shownImport && (
                                <input
                                  type='checkbox'
                                  name={item?.manager}
                                  id='import'
                                  checked={item.import}
                                  onChange={onChange}
                                  title={t('IMPORT')}
                                />
                              )}
                            </td>

                            <td className='py-2 px-2 border-r '>
                              {item?.shownAll && (
                                <input
                                  type='checkbox'
                                  id='all'
                                  name={item?.manager}
                                  onChange={checkAll}
                                  title={t('O_ALL')}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setShowModal(false)}
                >
                  {t('O_BACK')}
                </button>
                {loading ? (
                  <div className='spinner-container'>
                    <div className='loading-spinner' />
                  </div>
                ) : (
                  <OButton
                    disabled={!isDirty}
                    label={<>{t('O_ADD')}</>}
                    type='submit'
                    onClick={handleSubmit(onSubmit)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SubAdd
